jQuery(function ($) {
    $(document).on("click", ".sa_mega-menu__main-menu__list-link", function () {
        var click_target = $(this).attr("data-target");
        $(this)
            .closest(".sa_mega-menu")
            .find(".sa_sub-menu__group")
            .removeClass("active");
        $(this)
            .closest(".sa_mega-menu")
            .find(".sa_mega-menu__sub-menu")
            .removeClass("active");
        $(this)
            .closest(".sa_mega-menu")
            .find(".as_mega-menu_product_main-category")
            .removeClass("active");
        $(this)
            .closest(".sa_mega-menu")
            .find(".sa_mega-menu__main-menu__list-link")
            .removeClass("active");

        $(this)
            .closest(".sa_mega-menu")
            .find(".sa_mega-menu__sub-menu")
            .addClass("active");
        $(click_target)
            .find(".sa_sub-menu__group__list li:first-child .sub-menu_product-link")
            .trigger("click");

        $(this).addClass("active");
        $(click_target).addClass("active");
        $(click_target + "_product").addClass("active");
    });

    $(document).on("click", ".sub-menu_product-link", function () {
        var click_target = $(this).attr("data-target");
        $(this)
            .closest(".sa_mega-menu")
            .find(".sa_mega-menu__product")
            .removeClass("active");
        $(this)
            .closest(".sa_mega-menu")
            .find(".sa_mega-menu__product-group")
            .removeClass("active");
        $(this)
            .closest(".sa_mega-menu")
            .find(".sub-menu_product-link")
            .removeClass("active");

        $(this)
            .closest(".sa_mega-menu")
            .find(".sa_mega-menu__product")
            .addClass("active");
        $(this).addClass("active");
        $(click_target).addClass("active");
        $(click_target).parent().addClass("active");
    });

    $(document).on(
        "click",
        ".mega-menu-item-has-children > .nav-link",
        function () {
            if ($(".navbar .mega-menu-item-has-children").hasClass(".active")) {
                $(".navbar .mega-menu-item-has-children").removeClass("active");
            }

            $(this)
                .closest(".mega-menu-item-has-children")
                .find(
                    ".sa_mega-menu__main-menu .sa_mega-menu__main-menu__list li:first-child .sa_mega-menu__main-menu__list-link"
                )
                .trigger("click");
            $(this)
                .closest(".mega-menu-item-has-children")
                .find(
                    ".sa_mega-menu__sub-menu .sa_sub-menu__group:nth-child(2) .accordion-item:first-child ul li:first-child .sub-menu_product-link"
                )
                .trigger("click");
            $(this)
                .closest(".mega-menu-item-has-children")
                .find(
                    ".sa_mega-menu__sub-menu .sa_sub-menu__group:nth-child(2) .sa_sub-menu__group__list li:first-child .sub-menu_product-link"
                )
                .trigger("click");
            $(this).closest(".mega-menu-item-has-children").toggleClass("active");
        }
    );

    $(document).on("click", ".sa_mega-menu__main-menu__back", function () {
        $(this).closest(".mega-menu-item-has-children").removeClass("active");
    });

    $(document).on("click", ".sa_mega-menu__sub-menu__back", function () {
        $(this).closest(".sa_mega-menu__sub-menu").removeClass("active");
    });

    $(document).on("click", ".sa_mega-menu__product__back", function () {
        $(this).closest(".sa_mega-menu__product").removeClass("active");
    });
});
